__turbopack_context__.v({
  "video-content": "video-content-module-scss-module__fI1wfa__video-content",
});
